import { Divider, Popover, Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";

interface Props {
  anchorEl: HTMLElement;
  title: string;
  onClose: () => void;
}

const CardConditionsPopover = ({ anchorEl, title, onClose, children }: PropsWithChildren<Props>) => (
  <Popover
    open
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    slotProps={{ paper: { sx: { width: 300, maxWidth: "calc(100vw - 32px)" } } }}
  >
    <Stack role="dialog" aria-label={`Conditions for ${title}`}>
      <Stack spacing={0.5} sx={{ px: 2, py: 1.5 }}>
        <Typography color="textSecondary" variant="caption">
          Conditions
        </Typography>
        <TypographyTooltipEllipsis text={title} />
      </Stack>
      <Divider />
      {children}
    </Stack>
  </Popover>
);

export default CardConditionsPopover;
